<template>
  <div>
    <el-row class="tagrow" type="flex" justify="end">
      <el-col :span="type != 3?17:24" class="clearfix dragArea">
        <el-row >
          <el-col >
            <slot></slot>
          </el-col>
          
        </el-row>
        <!-- <div class="fl tag_content">

        </div>
        <div class="tag_btn fr ar" style="box-sizing: border-box;padding-right: 15px;">

        </div> -->
        <TaskSearch :taskClass="taskClass" ref="taskSearch"></TaskSearch>
      </el-col>

      <el-col :span="3" :offset="3">
            <el-button @click="searchTask" size="mini" type="primary">精确搜索</el-button>
      </el-col>
      <el-col :span="9" class="tagSearch" v-show="type != 3" style="padding-left: 10px;">
        <!--<el-input
          placeholder="请输入关键字"
          v-model="searchParams.KeyWord"
          @keyup.enter.native="LuneceSearch"
          size="mini"
        >
          <el-button slot="append" icon="el-icon-search" @click="LuneceSearch"></el-button>
        </el-input>-->
        <el-input
          style="max-width:300px"
          :placeholder="searchPlaceholder"
          v-model="searchParams.KeyWord"
          @keyup.enter.native="LuneceSearch"
          size="mini"
        >
          <el-select
            v-model="searchRange"
            slot="prepend"
            style="width:100px; vertical-align: baseline;"
            @change="changeRange"
            placeholder="请选择"
          >
            <el-option label="全部范围" :value="0"></el-option>
            <el-option label="当前范围" :value="1"></el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-search" @click="LuneceSearch"></el-button>
        </el-input>
      </el-col>
    </el-row>
    <!-- <div>
				<el-card class="">
					<div slot="header" class="clearfix">
						<span>创建结果集</span>
					</div>
				</el-card>
				<ul>
					<li v-for="(taskName,index) in pendingTaskList"></li>
				</ul>
    </div>-->
    <!-- <el-row class="tagTemplate">
				<el-col :span="24">
					<templateTag class="templateTag"></templateTag>
				</el-col>
    </el-row>-->
  </div>
</template>

<script>
import searchJs from "@/util/search";
import TaskSearch from "@/views/task/components/TaskSearch.vue";
export default {
  props: {
    taskClass: {
      type: String,
      default: ""
    },
    templateQuery: Object
  },
  data() {
    return {
      type: this.$route.query.type || 2,
      searchRange: 0,
      searchPlaceholder: "请输入关键字",
      searchParams: {
        KeyWord: "", //全文搜索关键字
        CreateUserId: "",
        ExcuteUserId: "",
        TaskState: "",
        ServerCenterId: "",
        Menu: "0",
        TaskType: ""
      }
    };
  },
  mounted() {},
  methods: {
    changeRange() {
      this.searchPlaceholder =
        this.searchRange == 0 ? "全文检索自动分词匹配" : "任务标题模糊搜索";
    },
    LuneceSearch() {
      // if (this.searchParams.KeyWord) {
      //   let para = Object.assign({}, this.searchParams);
      //   this.$store.dispatch("changeLuneceTaskParas", para);
      // }
      //0为全文检索    1为当前模板条件下任务标题模糊搜索
      if (this.searchParams.KeyWord) {
        if (this.searchRange == 0) {
          let para = Object.assign({}, this.searchParams);
          this.$store.dispatch("changeLuneceTaskParas", para);
        } else {
          console.log(this.$store.state.task.searchParams);
          let para = Object.assign({}, this.$store.state.task.searchParams);
          para.TaskName = this.searchParams.KeyWord;
          this.$store.dispatch("changeTaskParas", searchJs.searchTask(para, 0));
          // this.$emit("LuneceSearch", this.searchParams.KeyWord);
        }
      } else {
        this.$store.dispatch(
          "changeTaskParas",
          searchJs.searchTask(this.$store.state.task.searchParams, 0)
        );
      }
    },
    searchTask() {
      switch (this.type) {
        case "3":
          break;
        default:
          // templateQuery
          if (this.templateQuery.CONTENT) {
            let content = JSON.parse(this.templateQuery.CONTENT);
            this.$store.commit("setQueryTask", content);
            this.$refs.taskSearch.SearchOpen(2);
          } else {
            this.$refs.taskSearch.SearchOpen();
          }
          break;
      }
    },
    dragAreaOver() {
      this.$store.state.task.isDragArea = true;
    },
    dragAreaOut() {
      this.$store.state.task.isDragArea = false;
    },
    allTask() {
      this.$refs.taskSearch.allTask();
    },
    onViewTypeChange(type) {
      let viewType = this.ViewTypeState.filter(item => item.value === type);
      if (viewType.length > 0) {
        this.ViewTypeName = viewType[0].name;
        this.$emit("viewTypeChange", type);
      }
    },
    stateChange(val) {}
  },
  computed: {
    pendingTaskList: function() {
      return this.$store.state.task.pendingTaskList;
    },
    tagItem: function() {
      return this.$store.state.task.tagItem;
    }
  },
  components: {
    TaskSearch
    // templateTag
  }
};
</script>

<style scoped>
.tagrow {
  background: white;
  padding: 18px 10px 16px 10px;
  /* border-top: 1px solid #eaecf2; */
  border-bottom: 1px solid #eaecf2;
}
.tagTemplate {
  background: white;
  padding: 0 35px 0 24px;
}
.tag_btn {
  margin-bottom: 8px;
  /* width: 25%; */
  margin-right: 10px;
}
.tag_content {
  width: 85%;
  box-sizing: border-box;
  padding: 0 10px;
}
/* .templateTag{
			width: 87%;
			word-wrap: break-word;
			margin-top: 2px;
		} */
/* .dragArea{
			border: 1px solid #91d5ff;
			background-color: #e6f7ff;
			border-radius: 4px;
			padding: 10px 0 0 10px;
		} */
.topCard {
  /* font-size: 12px; */
}
</style>
